import { useEffect, useState } from 'react'
import { Box, Card, CardHeader, CardBody, Heading, Text, Spinner, VStack } from '@chakra-ui/react'
import { useNavigate, useParams } from 'react-router-dom'
import { AdminLayout } from '@/components/layout/AdminLayout'
import { ClientForm } from '@/components/forms/ClientForm'
import { useThemeColors } from '@/hooks/useThemeColors'

export default function EditClientPage() {
  const colors = useThemeColors()
  const navigate = useNavigate()
  const { id } = useParams<{ id: string }>()
  const numericId = id ? Number(id) : undefined
  const [isValidating, setIsValidating] = useState(true)

  useEffect(() => {
    if (!numericId || Number.isNaN(numericId)) {
      navigate('/organization/clients', { replace: true })
    } else {
      setIsValidating(false)
    }
  }, [numericId, navigate])

  const handleSuccess = () => {
    navigate('/organization/clients')
  }

  const handleCancel = () => {
    navigate('/organization/clients')
  }

  if (isValidating || !numericId) {
    return (
      <AdminLayout>
        <Box p={4} h="full" overflow="hidden" display="flex" flexDirection="column">
          <Card h="full" display="flex" flexDirection="column">
            <CardBody flex="1" display="flex" alignItems="center" justifyContent="center">
              <VStack spacing={4}>
                <Spinner size="xl" color="blue.500" />
                <Text>Loading...</Text>
              </VStack>
            </CardBody>
          </Card>
        </Box>
      </AdminLayout>
    )
  }

  return (
    <AdminLayout>
      <Box p={4} h="full" overflow="hidden" display="flex" flexDirection="column">
        <Card h="full" display="flex" flexDirection="column">
          <CardHeader flexShrink={0}>
            <Heading size="md">Edit Client</Heading>
            <Text fontSize="sm" color={colors.text} mt={1}>
              Update client information and configuration
            </Text>
          </CardHeader>
          <CardBody overflowY="auto" flex="1" minH={0}>
            <ClientForm clientId={numericId} onSuccess={handleSuccess} onCancel={handleCancel} />
          </CardBody>
        </Card>
      </Box>
    </AdminLayout>
  )
}
